import { queryBuilder } from '@lbs/swarm-client';

export const getVirtualGameVideo = (videoId, provider) => ({
  video_id: videoId,
  provider,
});

export const getVirtualResultGamesFilters = (startDate, endDate, selectedSport) => ({
  from_date: Math.floor(new Date(startDate).getTime() / 1000),
  to_date: Math.floor(new Date(endDate).getTime() / 1000),
  sport_id: selectedSport?.id,
  live: 0,
});

export const getVirtualSportWithGameCount = (sportType) => (
  queryBuilder()
    .useSource('betting')
    .selectSport(['id', 'name', 'alias', 'order'])
    .whereSport('type')
    .in(sportType)
    .getParams()
);
